<template>
  <div class="footer" :class="{ 'mobile-layout': isMobile }">
    <!-- 左侧：GRAVITY GAME VISION 标志和版权信息 -->
    <div class="left">
      <div class="logo gravity-logo"></div>
      <p class="copyright" v-if="!isMobile">
        <cite
          >© Gravity Co.,Ltd. & LeeMyoungJin(studio DTDS) All rights
          reserved.</cite
        >
      </p>
    </div>

    <!-- 右侧：游戏评级、内容说明和服务条款 -->
    <div class="right">
      <div class="rating-block">
        <div class="rating-icon"></div>
        <div class="rating-content">
          <div class="rating-text">
            <div>本遊戲內容涉及暴力、戀愛交友</div>
            <div>本遊戲部份內容需另行支付費用</div>
            <div>請避免沉迷遊戲</div>
          </div>
          <div class="terms">
            <a
              href="https://gpassport.gnjoy.hk/center/ServicePrivicy/service?language=zh-TW&gameId=386"
              target="_blank"
              >服務條款</a
            >
            <span class="separator" v-if="!isMobile">|</span>
            <a
              href="https://gpassport.gnjoy.hk/center/ServicePrivicy/privicy?language=zh-TW&gameId=386"
              target="_blank"
              >隱私政策</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端版权信息 -->
    <p class="copyright mobile-copyright" v-if="isMobile">
      <cite
        >© Gravity Co.,Ltd. & LeeMyoungJin(studio DTDS) All rights
        reserved.</cite
      >
    </p>
  </div>
</template>

<script setup>
import { inject } from "vue";

const isMobile = inject("isMobile");
</script>

<style scoped>
.footer {
  width: 100%;
  min-height: 160px;
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 60px;
  box-sizing: border-box;
  position: relative;
}

/* 左侧：GRAVITY GAME VISION 标志和版权 */
.left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  max-width: 450px;
}

.gravity-logo {
  width: 280px;
  height: 70px;
  background-image: url("../assets/images/footer/gnjoy-logo-big.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
}

.copyright {
  margin: 0;
  font-size: 14px;
  color: #888888;
  line-height: 1.5;
}

.copyright cite {
  font-style: normal;
  font-weight: 400;
}

/* 右侧：游戏评级、内容说明和服务条款 */
.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  max-width: 600px;
}

.rating-block {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.rating-icon {
  width: 60px;
  height: 60px;
  background-image: url("../assets/images/grade_12.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
}

.rating-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rating-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #cccccc;
  font-size: 14px;
  line-height: 1.4;
}

.rating-text div {
  margin: 0;
}

.terms {
  display: flex;
  align-items: center;
  gap: 12px;
}

.terms a {
  color: #888888;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.terms a:hover {
  color: #ffffff;
}

.separator {
  color: #555555;
  font-size: 14px;
}

/* 移动端版权信息样式 */
.mobile-copyright {
  order: 3;
  margin-top: 20px;
}
</style>
